<template>
  <div style="padding-bottom:7vw" v-loading="loading">
    <headers />

    <div id="login_wrap_denglu">
      <div class="login_wrap_denglu_top">申请合适的方案</div>
      <div class="yanzhengma_enter">更懂教育的一站式互动解决方案</div>
    </div>

    <div class="page flex-col">
    <div class="main1 flex-col">
      <div class="group4 flex-col">
        <div class="bd1 flex-row">
          <img
            class="label1"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng9de55ca2faff381135937e8f76f5be80eaa419a67819bdfecc1c19c377146dc2.png"
          />
          <span class="word4">限时特惠</span>
          <span class="txt4">
            最近暂无优惠，敬请期待。
          </span>
          <!-- <span class="info3">查看活动详情</span> -->
        </div>
      </div>
      <div class="group5 flex-row">
        <div class="mod1 flex-col"></div>
        <span class="info4">申请须知</span>
        <span class="info5">专业学校版本&nbsp;线下教室账号10个起</span>
      </div>

      <div class="group6 flex-row">
        <div class="mod2 flex-col"></div>
        <span class="txt5">选择配置</span>
      </div>

      <div class="group7 flex-row">
        <span class="word5"></span>

        <div class="box1 flex-col" :class="{ 
            selectedStatus: userSelectVersion == 1
         }" @click="change_version(1)">
          <div class="mod3 flex-col">
            <div class="flex-col " :class="{ 
                block1: userSelectVersion == 1,
                box4: userSelectVersion != 1
            }">
              <span class="txt9">试用版</span>
            </div>
            <div class="box5 flex-row"  v-for="(item, index) in freeVersions" :key="'sy-' + index" >
              <div class="wrap2 flex-col"></div>
              <span class="word12">{{item}} </span>
            </div>
          </div>
        </div>

        <div class="box3 flex-col" :class="{ 
            selectedStatus: userSelectVersion == 2
         }" @click="change_version(2)">
          <div class="mod3 flex-col ">
            <div class="flex-col"  :class="{ 
                block1: userSelectVersion == 2,
                box4: userSelectVersion != 2
            }">
              <span class="txt9">学校版</span>
            </div>
            <div class="box5 flex-row"  v-for="(item, index) in schoolVersions" :key="'xx-' + index">
              <div class="wrap2 flex-col"></div>
              <span class="word12"> {{item}} </span>
            </div>
          </div>
        </div>

        <div class="box3 flex-col" :class="{ 
            selectedStatus: userSelectVersion == 3
         }" @click="change_version(3)">
          <div class="mod3 flex-col">
            <div class=" flex-col"  :class="{ 
                block1: userSelectVersion == 3,
                box4: userSelectVersion != 3
            }">
              <span class="txt9">专业学校版</span>
            </div>
            <div class="box5 flex-row"  v-for="(item, index) in schoolProVersions" :key="'zy-' + index">
              <div class="wrap2 flex-col"></div>
              <span class="word12">{{item}}</span>
            </div>
          </div>
        </div>
        
      </div>

      <div class="group20 " v-show="userSelectVersion != 1">
        <span class="txt12">必选服务</span>
         <div class="bd3 flex-col " :class="{
             selectedStatus: xxjs.planCount > 0
         }">
            <div class="mybox">
                <span class="word18">线下教室账号</span>
                <span class="info18">买多少线下教室账号，就有多少方开课能力。购买线下教室账号，可以创建双师课堂。</span>
            </div>
            <el-input-number v-model="xxjs.planCount" :min="xxjs.minCount" :max="1000" label="" size="mini"  class="inputNumber"
            ></el-input-number>
        </div>
      </div>

       <div class="group20" v-for="(item, index) in peopleCount" :key="'xx-xsls-' + index" v-show="userSelectVersion == 2">
         <div class="bd3 flex-col" :class="{
                selectedStatus : item.school_xsls.planCount > 0
             }">
            <div class="mybox">
                <span class="word18">线上老师账号（{{item.count}}方）</span>
                <span class="info18">购买该类型账号，可以创建最多{{item.count}}人的线上课程。</span>
            </div>
            <el-input-number :min="0" :max="1000" label="" size="mini"  class="inputNumber" v-model="item.school_xsls.planCount"
            ></el-input-number>
        </div>
      </div>

      <div class="group21 " v-show="userSelectVersion == 3">
         <div class="bd3 flex-col " :class="{
             selectedStatus : pro_xsls.planCount > 0
         }">
            <div class="mybox2">
                <span class="word18">线上老师账号</span>
                <div class="flex-row" style="padding-top:1vh;padding-bottom:1vh">
                    <div class="flex-col" style="margin-left:0.72vw"></div>
                    <div class="flex-col" v-for="(item, index) in peopleCount" :key="'zy-xsls-' + index" :class="{
                        group69 : pro_xsls.peopleCount == item.count,
                        group70:  pro_xsls.peopleCount != item.count
                    }" @click="changeXslsCount(item.count)" > {{item.count}}方</div>
                </div>
                <span class="info18">购买该类型账号，可以创建线上课程。</span>
            </div>
            <el-input-number :min="0" :max="1000" label="" size="mini"  class="inputNumber2" v-model="pro_xsls.planCount"
            ></el-input-number>
        </div>
      </div>

       <div class="group20 " v-show="userSelectVersion != 1">
        <span class="txt12">拓展服务</span>
         <div class="bd3 flex-col" :class="{
             selectedStatus : ycc.planCount > 0
         }">
            <div class="mybox">
                <span class="word18">云录制存储空间</span>
                <span class="info18">如果用到云录制功能，需要购买此服务，用于存储视频回放。申请单位：GB。</span>
            </div>
            <el-input-number :min="0" :max="1000" label="" size="mini"  class="inputNumber" v-model="ycc.planCount"
            ></el-input-number>
        </div>
      </div>

    <div class="group20 " v-for="(item, index) in peopleCount" :key="'xx-xxjs-' + index"  v-show="userSelectVersion == 2" >
         <div class="bd3 flex-col"  :class="{
                selectedStatus : item.school_xxjs_xykz.planCount > 0
             }">
            <div class="mybox">
                <span class="word18">线下教室-线上学员扩展（{{item.count}}方）</span>
                <span class="info18">购买该扩展，可以创建混合课堂，允许最多{{item.count}}个线上学员加入到双师课堂中。</span>
            </div>
            <el-input-number :min="0" :max="1000" label="" size="mini"  class="inputNumber" v-model="item.school_xxjs_xykz.planCount"
            ></el-input-number>
        </div>
    </div>

      <div class="group21 " v-show="userSelectVersion == 3">
         <div class="bd3 flex-col" :class="{
                selectedStatus : pro_xxjs_xykz.planCount > 0
             }">
            <div class="mybox2">
                <span class="word18">线下教室-线上学员扩展</span>
                <div class="flex-row" style="padding-top:1vh;padding-bottom:1vh">
                    <div class="flex-col" style="margin-left:0.72vw"></div>
                    <div class=" flex-col" v-for="(item, index) in peopleCount" :key="'zy-xykz-' +index" :class="{
                        group69 : pro_xxjs_xykz.peopleCount == item.count,
                        group70:  pro_xxjs_xykz.peopleCount != item.count
                    }" @click="changeXykzCount(item.count)" >{{item.count}}方</div>
                </div>
                <span class="info18">购买该扩展，可以创建混合课堂，允许线上学员加入到双师课堂中。</span>
            </div>
            <el-input-number :min="0" :max="1000" label="" size="mini"  class="inputNumber2" v-model="pro_xxjs_xykz.planCount"
            ></el-input-number>
        </div>
      </div>

      
    <div class="group6 flex-row">
        <div class="mod2 flex-col"></div>
        <span class="txt5">学校管理员</span>
      </div>
      
    <div class="group7 flex-row" style="margin-left: 13.9vw;    margin-top: -1.15vw; height: auto; min-height: 2vw">

        <div v-show="!changePhoneFlag">
            <div class="jigou_mingcheng_text">
            <span style="font-size: 0.9vw;margin-right:0.9vw">{{showPhone}}</span>   
            <div style="float:right;color: #3366ff;cursor:pointer;font-size: 0.9vw" @click="change_phone">更换</div>
            </div>
        </div>

        <!-- 更换手机号 -->
        <div style="height:130px;width:500px" v-show="changePhoneFlag">
            <div style="width:100px;float:left;">
                <el-select v-model="formData.area" placeholder="区号" filterable>
                    <el-option v-for="item in cities" :key="item.label" :label="item.value" :value="item.value" >
                    <span style="float: left">{{ item.label }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                    </el-option>
                </el-select>
            </div>
            <div style="width:265px;float:left;margin-left:5px" >
                <el-input type="number" v-model="formData.phone" placeholder="请输入手机号码" ></el-input>
            </div>
            <br>
            <div style="width:180px;float:left;margin-top:10px;margin-right:5px">
                <el-input placeholder="请输入验证码" type="number"  v-model="formData.validatorCode"  ></el-input>
            </div>
            <div style="float:left;margin-top:10px;" >
                <el-button  style="height: 40px;
                line-height: 40px;
                padding: 0px;
                width: 100px;
                border: 1px solid #C0C4CC;" @click="sendvalidatorCode"
                :disabled="isDisabled" >{{buttonName}}</el-button>
            </div>
            <div style="float:left;margin-top:10px;" >
                <el-button  style="height: 40px;line-height: 40px;padding: 0;width: 80px;margin-left:5px;
                border: 1px solid #C0C4CC;" @click="change_phone">取消</el-button>
            </div>
            <br> <br> <br> 
            <div style="font-size:0.7vw;color:#999;">完成手机号验证后，该号码将成为学校管理员，请谨慎填写。</div>

        </div>

      </div>
      
    <div class="group5 flex-row">
        <div class="mod1 flex-col"></div>
        <span class="info4">服务条款</span>
        <span class="info5">
            <el-checkbox style=" margin-left : 2.5vw" v-model="isRead">
            </el-checkbox>
            <span class="word59">我已阅读并同意</span>
            <span class="info37">《申请须知》</span>
            <span class="txt28">和</span>
            <span class="info37">《隐私政策》</span>
            <span class="word61">。</span>
        </span>
      </div>
        
      </div>
      <span class="txt29">
        此页面勾选的配置只是预计配置，最终的申请配置，请等待商务人员电话回访，与您进一步沟通。<br>
        系统以最终沟通结果为准，为您申请合适的账号配置。
        申请成功后，您也可以进入后台&nbsp;-&nbsp;费用中心&nbsp;-&nbsp;计划管理，更改您申请的配置。
      </span>

      <div class="group68 flex-col">
        <div class="section17 flex-row">
          <span class="txt30" v-show="userSelectVersion != 1 ">时长</span>

          <div class="flex-col" v-for="(item, index) in timeArr" :key="index" :class="{
                group69 : day.days == item.days,
                group70:  day.days != item.days
            }" @click="changeTime(item)" v-show="userSelectVersion != 1 &&
                (!item.version || userSelectVersion == item.version) ">{{item.name}}</div>

          <button class="group73 " @click="submit">
            <span class="info40">立即申请</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

    import headers from "./header.vue";
    import Net_Work from "../apis/network.js";
    import axios from "axios";
    import { try_get_token } from "../apis/token.js";
    import Address from "../apis/address.js";
    import Qs from "qs";

    axios.defaults.baseURL = Net_Work.publicApi;
    axios.defaults.headers.post["Content-Type"] = Net_Work.publicPostset;

    export default {
        components: {
            headers
        },
        data() {
            return {
                
                loading: false,

                // 用户选择的版本
                userSelectVersion: 1,

                // 是否阅读服务条款
                isRead: false,

                // 线下教室对象
                xxjs: {
                    planCount: 0,
                    minCount: 0
                },

                // 云存储空间对象
                ycc: {
                    planCount: 0
                },

                freeVersions: [
                    "互动教室",
                    "多种互动工具",
                    "后台管理系统",
                    "共享屏幕及互动批注",
                    "7天免费使用时长"
                ],

                schoolVersions: [
                    "试用版所有功能+",
                    "可选1080p高清画质",
                    "可选直播、录播回放功能",
                    "100GB免费云存储空间",
                    "自定义云录制储存天数",
                    "VIP售后服务群培训答疑"
                ],

                schoolProVersions: [
                    "学校版所有功能+",
                    "1080p高清画质",
                    "直播、录播回放功能",
                    "500GB免费云存储空间",
                    "API数据对接",
                    "更优惠的价格"
                ],

                // 时长选项
                timeArr: [
                    {
                        name: '1月',
                        days: 30,
                        version: 2
                    }, {
                        name: '3月',
                        days: 90,
                        version: 2
                    }, {
                        name: '6月',
                        days: 180,
                        version: 2
                    }, {
                        name: '1年',
                        days: 365
                    },{
                        name: '2年',
                        days: 365 * 2
                    },{
                        name: '3年',
                        days: 365 * 3
                    },{
                        name: '5年',
                        days: 365 * 5,
                        version: 3
                    }
                ],

                // 选择的时长
                day: {
                    name : '',
                    days: 30
                },

                // 专业版本 - 线上老师
                pro_xsls : {
                    // 计划数
                    planCount: 0,
                    // 方数
                    peopleCount: 10
                },

                // 专业版本 - 线下教室-学员扩展
                pro_xxjs_xykz: {
                    // 计划数
                    planCount: 0,
                    // 方数
                    peopleCount: 10
                },

                // 学校版
                peopleCount: [
                    {
                        count: 10,
                        school_xsls:{
                            planCount: 0
                        },
                        school_xxjs_xykz: {
                            planCount: 0
                        },
                    },
                    {
                        count: 25,
                        school_xsls:{
                            planCount: 0
                        },
                        school_xxjs_xykz: {
                            planCount: 0
                        }
                    },
                    {
                        count: 50,
                        school_xsls:{
                            planCount: 0
                        },
                        school_xxjs_xykz: {
                            planCount: 0
                        }
                    },
                    {
                        count: 100,
                        school_xsls:{
                            planCount: 0
                        },
                        school_xxjs_xykz: {
                            planCount: 0
                        }
                    },
                    {
                        count: 300,
                        school_xsls:{
                            planCount: 0
                        },
                        school_xxjs_xykz: {
                            planCount: 0
                        }
                    },
                    {
                        count: 500,
                        school_xsls:{
                            planCount: 0
                        },
                        school_xxjs_xykz: {
                            planCount: 0
                        }
                    },
                    {
                        count: 1000,
                        school_xsls:{
                            planCount: 0
                        },
                        school_xxjs_xykz: {
                            planCount: 0
                        }
                    },
                ],

                // 是否改变手机号状态位
                changePhoneFlag: false,
                // 显示手机号
                showPhone: '',

                // 验证码倒计时s
                timerCount: 60,
                buttonName: '获取验证码',
                isDisabled: false,

                // 国家区号列表
                cities: Address.citiy,

                // 表单数据
                formData: {
                    area: '',
                    // 手机号
                    phone: '',
                    // 验证码
                    validatorCode: '',
                    // 验证码key
                    validatorKey: '',
                    // 学校ID
                    schoolId: 0
                }

            };
        },
        methods: {

             // 切换手机号
            change_phone(){
                 this.changePhoneFlag = !this.changePhoneFlag;
            },

            // 切换版本
            change_version(version){

                if(version == 3){
                    // 教室切换
                    this.xxjs.minCount = 10;
                    this.xxjs.planCount = 10;
                    // 时长切换
                    this.day.days = 365;
                    this.day.name = "1年";
                } else {
                    this.xxjs.minCount = 0;
                    this.xxjs.planCount = 0;
                     // 时长切换
                    this.day.days = 30;
                    this.day.name = "1月";
                }

                this.userSelectVersion = version;
            },

            // 学员扩展方数变化
            changeXykzCount(num){
                this.pro_xxjs_xykz.peopleCount = num;
            },

            // 线上老师方数变化
            changeXslsCount(num){
                this.pro_xsls.peopleCount = num;
            },

            // 时间改变
            changeTime(item){
                this.day.days = item.days;
                this.day.name = item.name;
            },

            // 获取显示手机号
            getShowPhone(phone){
                var length = phone.length;
                if(length <= 4){
                    return "****";
                }

                var index = (length - 4) /2;
                return phone.replace(phone.substring(index ,index + 4), "****")
            },

            // 获取验证码
            sendvalidatorCode(){

                if(!this.formData.area){
                    this.$message.error({
                        showClose: true,
                        message: '请选择区号'
                    });
                    return;
                }

                if(!this.formData.phone){
                    this.$message.error({
                        showClose: true,
                        message: '请填写手机号'
                    });
                    return;
                }

                // 区号
                var number_quhao = Number(this.formData.area);
                var _this = this;

                axios.post("/n/api/sms/send", Qs.stringify({
                    areaCode: number_quhao,
                    phone: this.formData.phone
                }))
                .then(function(response) {
                    if (response.data.code == 0) {

                        // 设置验证码的key
                        _this.formData.validatorKey = response.data.data.key;

                        // 定时刷新倒计时
                        let clock = setInterval(() => {
                        _this.timerCount--;
                        _this.buttonName =  _this.timerCount + '秒';
                        if (_this.timerCount < 0) {
                            _this.timerCount = 60;
                            _this.isDisabled = false;
                            _this.buttonName = '获取验证码';
                            window.clearInterval(clock);
                        }
                        }, 1000);
                        
                        // 验证码按钮禁用
                        _this.isDisabled = true;

                    }  else {
                        _this.$message.error({
                            showClose: true,
                            message: response.data.msg
                        });
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });

            },

            // 数据提交
            submit(){
                
                var _this = this;

                // 没有阅读服务条款，则不允许提交
                if(!_this.isRead){
                     _this.$message.error({
                        message: "请先阅读服务条款。",
                        showClose: false
                    });
                    return;
                }

                // 如果手机号改变了
                if(_this.changePhoneFlag){

                     if(!_this.formData.area || !_this.formData.phone){
                        _this.$message.error({
                            message: "请填写手机号",
                            showClose: false
                        });
                        return;
                    }

                    if(!_this.formData.validatorKey){
                         _this.$message.error({
                            message: "请发送验证码",
                            showClose: false
                        });
                        return;
                    }

                    if(!_this.formData.validatorCode){
                         _this.$message.error({
                            message: "请填写验证码",
                            showClose: false
                        });
                        return;
                    }
                    
                }

                // 提交后台的数据结果
                var submitObj = {
                    "area": _this.formData.area,
                    "changePhoneFLag": _this.changePhoneFlag,
                    "phone": _this.formData.phone,
                    "validatorCode":  _this.formData.validatorCode,
                    "validatorKey":  _this.formData.validatorKey,
                    "planApply": {
                        "days": _this.day.days,
                        "daysName": _this.day.name,
                        "schoolId": _this.formData.schoolId,
                        "type": _this.userSelectVersion
                    },
                    "planList": []
                };

                // 非免费版，获取线下教室和云录制数据
                if(_this.userSelectVersion != 1){
                    // 线下教室
                    if( _this.xxjs.planCount > 0){
                        submitObj.planList.push({
                            "count": _this.xxjs.planCount,
                            "type": 1
                        });
                    }
                    // 云存储
                    if( _this.ycc.planCount > 0){
                        submitObj.planList.push({
                            "count": _this.ycc.planCount,
                            "type": 4
                        });
                    }
                }

                // 获取学校版本计划列表
                var teacherPlanCount = 0;
                var kzPlanCount = 0;
                if(_this.userSelectVersion == 2){
                    for(var i = 0 ; i < _this.peopleCount.length; i++){
                        // 老师计划
                        teacherPlanCount = _this.peopleCount[i].school_xsls.planCount
                        if(teacherPlanCount > 0){
                            submitObj.planList.push({
                                "count": teacherPlanCount,
                                "participantCount":  _this.peopleCount[i].count,
                                "type": 3
                            });
                        }
                        // 扩展计划
                        kzPlanCount = _this.peopleCount[i].school_xxjs_xykz.planCount;
                        if(kzPlanCount > 0){
                            submitObj.planList.push({
                                "count": kzPlanCount,
                                "participantCount":  _this.peopleCount[i].count,
                                "type": 2
                            });
                        }
                    }
                }

                // 专业版计划获取
                else if(_this.userSelectVersion == 3){

                    // 老师计划
                    teacherPlanCount = _this.pro_xsls.planCount;
                    if(teacherPlanCount > 0){
                        submitObj.planList.push({
                            "count": teacherPlanCount,
                            "participantCount": _this.pro_xsls.peopleCount,
                            "type": 3
                        });
                    }

                    // 扩展计划
                    kzPlanCount = _this.pro_xxjs_xykz.planCount;
                    if(kzPlanCount > 0){
                        submitObj.planList.push({
                            "count": kzPlanCount,
                            "participantCount": _this.pro_xxjs_xykz.peopleCount,
                            "type": 2
                        });
                    }

                }

                console.log(submitObj);

                _this.loading = true;
                axios.post("/o/api/planApply/apply", submitObj).then(response => {
                    if (response.data.code == 0) {
                         _this.loading = false;

                         _this.$alert('计划申请成功！您可以登录后台 - 切换学校管理员角色 - 计划管理，更改您申请的配置。', '申请成功提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                _this.$router.push("/password-login");
                            }
                        });
                        
                    } else {
                        _this.$message.error({
                            showClose: true,
                            message: response.data.msg
                        });
                        _this.loading = false;
                    }
                }).catch(function(error) {
                    _this.loading = false;
                });


            }

        },
        created(){

            var access_token = try_get_token();
            if (!access_token) {
                this.$router.push("/school-join");
                return ;
            } 

            axios.defaults.headers.common["Authorization"] = access_token;

            if(this.$route.query.version){
                this.userSelectVersion = this.$route.query.version;
                this.change_version(this.userSelectVersion );
            }

            var _this = this;
            
            // 获取学校基本信息
            axios.get("/s/api/school/getApplySchool").then(function(response) {
                if (response.data.code === 0) {
                    if (response.data.data) {

                        // 学校ID
                        _this.formData.schoolId = response.data.data.schoolId;

                        // 手机号分割
                        if(response.data.data.chargePersonPhone){
                            var phone = response.data.data.chargePersonPhone;
                            var index = phone.indexOf(" ");
                            if(index > -1){
                                _this.formData.area = "+" + phone.substring(0,index);
                                _this.showPhone = phone.substring(0,index) 
                                + _this.getShowPhone(phone.substring(index));
                            }
                        }
                    } 
                } 
            })
            .catch(function(error) {
                // handle error
            });
        }
    };

</script>
<style scoped lang="css" src="./assets/public.css" ></style>
<style scoped lang="css" src="./assets/common.css" ></style>
<style scoped lang="css" src="./assets/solution.apply.css" ></style>


// WEBPACK FOOTER //
// src/components/solution-apply.vue